export default function IconApplicationStep4() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-bcfe7435-fb25-48e4-84d2-7c2e5dbf8369"
      data-name="Layer 2"
      viewBox="0 0 56.477 60"
    >
      <defs>
        <style>
          {
            ".uuid-67cdba65-388d-4032-91a0-dfaa07daeec8{fill:var(--color-primary);stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-acc169f2-8079-420b-a002-23d6d7724b48" data-name="Layer 1">
        <path
          d="M56.477 60H14.13v-9.42h3.515v5.904h35.318V7.046H42.362V3.53h14.114V60zM17.644 30.601h-3.515V3.531h14.113v3.515H17.644V30.6z"
          className="uuid-67cdba65-388d-4032-91a0-dfaa07daeec8"
        />
        <path
          d="M44.121 10.576H26.484V0h17.637v10.576ZM30 7.06h10.605V3.517H30V7.06ZM35.295 35.303h14.114v3.516H35.295zM32.124 28.242h17.285v3.516H32.124zM35.295 42.363h14.114v3.516H35.295zM32.124 49.424h17.285v3.516H32.124zM19.41 52.94c-6.81 0-12.35-5.54-12.35-12.35s5.54-12.348 12.35-12.348 12.348 5.54 12.348 12.349-5.54 12.348-12.349 12.348Zm0-21.182c-4.872 0-8.834 3.962-8.834 8.833s3.963 8.833 8.833 8.833 8.833-3.963 8.833-8.833-3.962-8.833-8.833-8.833Z"
          className="uuid-67cdba65-388d-4032-91a0-dfaa07daeec8"
        />
        <path
          d="M7.479 60 0 52.522l8.625-8.625 2.486 2.486-6.14 6.139 2.508 2.506 6.138-6.139 2.486 2.486L7.478 60zM18.444 45.92l-4.995-4.996 2.486-2.486 2.51 2.51 4.439-4.44 2.486 2.486-6.926 6.925zM21.182 21.182h28.227v3.516H21.182zM21.182 14.121h28.227v3.516H21.182z"
          className="uuid-67cdba65-388d-4032-91a0-dfaa07daeec8"
        />
      </g>
    </svg>
  );
}
